import processAliases from "../../Main/aliases/process-aliases";
import prepareString from "../../Main/store/utils/prepare-string";
import processVariables from "../../Main/variables/process-variables";
import extractFirstLevelSpaces from "./extract-first-level-spaces";
import optimizeSingleAttribute from "./optimize-single-attribute";

/**
 * Optimize string
 * @param {MainClassProps} main
 * @returns {Array<String>}
 */
const processDataset = (main) => {
  const dataset = main.dataset;

  let attributes = [];

  /** @type {String} */
  const replaced = dataset
    .replace(/\n+/g, "")
    .replace(/\s+/g, " ")
    .replace(/\s?:\s?/g, ":")
    .trim();

  /** @type {Array<String>} */
  const spaces = extractFirstLevelSpaces(replaced);

  const aliases = processAliases(spaces);

  /** @type {Array<String>} */
  const variables = processVariables(main, aliases);

  for (const attribute of variables) {
    attributes.push(optimizeSingleAttribute(attribute));
  }

  attributes = prepareString(attributes);
  // console.log(attributes);
  return attributes;
};

export default processDataset;
